import axios from 'axios'
import store from '@/store'

// 创建axios实例
const service = axios.create({
    baseURL: window.config.BASE_API,
    timeout: 30000
})

// request拦截器
service.interceptors.request.use(config => {
    // 在请求发送之前做一些处理
    // config.headers['orgId'] = store.getters.orgId
    return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
    response => {
        const res = response.data
        if (res.code !== 200) {
            return Promise.reject('error')
        } else {
            return res
        }
    },
    error => {
        console.log('err' + error)// for debug
        return Promise.reject(error)
    }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js